module.exports = __webpack_public_path__ + "img/space-introduce-2.06e30659.svg";